import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../stores/store';
import {
  fetchKozelUserScores,
  addKozelScore,
} from '../../features/games/kozelBattleSlice';
import BattleGamePopup from './BattleGamePopup';
//import BattleGamePopupT from '../KozelBattleT/BattleGamePopupT';

interface GameProps {
  onBack?: () => void;
}

const Game: React.FC<GameProps> = ({ onBack }) => {
  const dispatch = useAppDispatch();
  const { uuid, userLightScore, userDarkScore } = useAppSelector(
    (state) => state.kozelBattle
  );
  const [showPopup, setShowPopup] = useState(false);
  const [gameOverScore, setGameOverScore] = useState(0);

  useEffect(() => {
    const userId = uuid || localStorage.getItem('kozelBattleUuid');
    if (userId) {
      dispatch(fetchKozelUserScores(userId));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'KOZEL_GAME_OVER') {
        const { score, chosenMole } = event.data;
        const userId = uuid || localStorage.getItem('kozelBattleUuid');

        // Save score to backend (existing logic)
        if (userId && typeof score === 'number' && score > 0) {
          const team: 'light' | 'dark' = chosenMole === 0 ? 'light' : 'dark';
          dispatch(addKozelScore({ unique_id: userId, team, score }));
        }

        // Open popup
        setGameOverScore(typeof score === 'number' ? score : 0);
        setShowPopup(true);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [uuid, dispatch]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>

      {/* TOP: Scorurile personale */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: { xs: '8px 16px', sm: '12px 32px' },
        backgroundColor: '#40301E',
        borderBottom: '2px solid #D1A85E',
        flexShrink: 0,
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{
            color: '#E3CB9F',
            fontSize: { xs: '0.7rem', sm: '0.85rem' },
            fontWeight: 'bold',
            letterSpacing: 1,
          }}>
            #TEAMBLONDE
          </Typography>
          <Typography sx={{
            color: '#E3CB9F',
            fontSize: { xs: '1.4rem', sm: '2rem' },
            fontWeight: 'bold',
          }}>
            {userLightScore}
          </Typography>
          <Typography sx={{ color: '#E3CB9F', fontSize: '0.7rem' }}>
            punctele tale
          </Typography>
        </Box>

        <Typography sx={{
          color: '#E3CB9F',
          fontSize: { xs: '0.75rem', sm: '1rem' },
          fontWeight: 'bold',
          textAlign: 'center',
        }}>
          SCORURILE TALE
        </Typography>

        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{
            color: '#E3CB9F',
            fontSize: { xs: '0.7rem', sm: '0.85rem' },
            fontWeight: 'bold',
            letterSpacing: 1,
          }}>
            #TEAMDARK
          </Typography>
          <Typography sx={{
            color: '#E3CB9F',
            fontSize: { xs: '1.4rem', sm: '2rem' },
            fontWeight: 'bold',
          }}>
            {userDarkScore}
          </Typography>
          <Typography sx={{ color: '#E3CB9F', fontSize: '0.7rem' }}>
            punctele tale
          </Typography>
        </Box>
      </Box>

      {/* MIDDLE: iframe */}
      <Box sx={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
        <iframe
          src="/whackamole/game/index.html"
          title="Kozel Battle"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
          }}
          allow="autoplay"
        />
      </Box>

      {/* BOTTOM: back button */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: { xs: '8px 16px', sm: '12px 32px' },
        backgroundColor: '#40301E',
        borderTop: '2px solid #D1A85E',
        flexShrink: 0,
      }}>
        <Button
          onClick={onBack}
          variant="contained"
          sx={{
            backgroundColor: '#D1A85E',
            color: '#1a0a00',
            fontWeight: 'bold',
            fontSize: { xs: '0.75rem', sm: '0.9rem' },
            padding: { xs: '8px 20px', sm: '10px 32px' },
            '&:hover': { backgroundColor: '#ffffff' },
          }}
        >
          ← ÎNAPOI LA PAGINA PRINCIPALĂ
        </Button>
      </Box>

      {/* POPUP: shown at game over */}
      <BattleGamePopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        score={gameOverScore}
      />

    </Box>
  );
};

export default Game;